/* eslint-disable max-lines-per-function */
import React, { useState } from "react";
import { omit } from "lodash";
import { FormControl, FormHelperText, InputLabel, MenuItem, Select } from "@material-ui/core";
import { isInputValid } from "../form-utils";
const isNil = (value: any) =>
  typeof value === "undefined" || value === null;


const propsToOmit = [
  "options",
  "formData",
  "onChangeAction",
  "onBlurAction",
  "persistTableName",
  "validationSchema",
];
export const SelectBasic: React.FC<{
  name: string;
  margin: "none" | "dense" ;
  label: string;
  options: { label: string; value: string, disabled?: boolean }[];
  onChangeAction: (element:any, props: any) => void;
  onBlurAction: (props: any) => void;
  validationSchema: any[];
  required?: boolean;
  defaultValue: string | null;
  value?: string | null;
  formData: any
}> = (args) => {
  const props = {
    ...args,
    onChangeAction: args.onChangeAction ?? (() => null),
    onBlurAction: args.onBlurAction ?? (() => null),
    validationSchema: args.validationSchema ?? [],
  };
  const [errMsg, setErrMsg] = useState("");
  const handleBlur = () => {
    if (props.validationSchema.length > 0) {
      const [isValid, newErrMsg] = isInputValid(props);
      if (!isValid) {
        setErrMsg(newErrMsg);
      }
    }
    props.onBlurAction(props);
  };
  const newProps = omit(props, propsToOmit);
  // prevent react from complaining about null values
  if (props.value === null) {
    newProps.value = "Select";
  } else if (props.defaultValue === null && !props.value) {
    newProps.defaultValue = "Select";
  } else if (isNil(props.defaultValue) && typeof props.value === "undefined") {
    newProps.defaultValue = "Select";
  }

  if (newProps.value) delete newProps.defaultValue;

  const options = props.options.map((option) => {
    if (typeof option !== "object") return { label: option, value: option };
    return option;
  });

  return (
    <FormControl fullWidth variant="outlined" margin={props.margin || "dense"}
      required={props.required} error={!!errMsg} style={{ margin: ".5em 0" }}>
      <InputLabel id={`${props.name}-label`}>{props.label}</InputLabel>
      <Select
        labelId={`${props.name}-label`}
        margin={props.margin || "dense"}
        label={props.label}
        name={props.name}
        id={props.name}
        onChange={(e) => props.onChangeAction(null, e)}
        onBlur={handleBlur}
        onFocus={() => setErrMsg("")}
        {...newProps}
      >
        <MenuItem disabled value="Select">
            Select
        </MenuItem>
        {!props.children &&
            options.map(({ label, value, disabled }, i) => (
              <MenuItem key={i} value={value} disabled={disabled}>
                {label}
              </MenuItem>
            ))}
      </Select>

      {errMsg && (<FormHelperText>{errMsg}</FormHelperText>)}
    </FormControl>
  );
};

export default SelectBasic;
